import { ParameterParams } from "./parameterTypes";
import { FusaReply } from "./replyTypes";

export interface ContextLogParams {
  id: string;
  subjectId: string;
  subjectType: CONTEXT_LOG_SUBJECT_TYPES;
  note: string;
  userEmail: string;
  createdAt?: Date | string;
  updatedAt?: Date | string;
  status: CONTEXT_LOG_STATUS;
  completionStatus?: CONTEXT_LOG_COMPLETION_STATUS;
  procedureContextBreadcrumb?: string;
  /** The org that owns the log. ContextLogAccess writes it from the writer org; callers never choose it. */
  propelOrgId?: string;
}

export interface ContextLogData extends ContextLogParams {
}

export type ContextLogCreateData = Omit<ContextLogData, 'id' | 'createdAt' | 'updatedAt'>;

export type ContextLogBulkCreateData = Omit<ContextLogData, 'createdAt' | 'updatedAt'>;

export enum CONTEXT_LOG_SUBJECT_TYPES {
  STEP = 'step',
  VALIDATION = 'validation',
  PARAMETER = 'parameter',
  REPORT_ITEM = 'report_item',
  REPORT = 'report',
};

export enum CONTEXT_LOG_STATUS {
  PENDING = 'pending',
  COMMITTED = 'committed',
};

export enum CONTEXT_LOG_COMPLETION_STATUS {
  PASSED = 'passed',
  FAILED = 'failed',
  NOT_APPLICABLE = 'not_applicable',
};
export interface ContextLogCreateRequest extends Omit<ContextLogCreateData, 'status'> {}

export interface ContextLogCreateResponse extends FusaReply {
  contextLog: ContextLogParams;
};

export interface ContextLogCreateParameterResponse extends FusaReply {
  contextLog: ContextLogParams;
  parameter: ParameterParams;
};

export interface ContextLogCommitParameterResponse extends FusaReply {
  updatedParameters: ParameterParams[];
  contextLog: ContextLogParams;
};

export interface ContextLogCommitRequest {
  note: string;
  userEmail: string;
  contextLogId: string;
};

export interface ContextLogReadAllResponse extends FusaReply {
  contextLogs: ContextLogParams[];
};

export interface DeleteContextLogsForSubjectRequest {
  subjectId: string;
  subjectType: CONTEXT_LOG_SUBJECT_TYPES;
};

